<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.fabricante"
        ref="DataTable"
        sort-by="nome"
    >
        <template v-slot:cell(cnpj)="row">
            {{ row.value | cnpj }}
        </template>

        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'cadastro-fabricante-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-cadastro-fabricante"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-cadastro-fabricante"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

// Filters.
import formats from '@/filters/formats'

export default {
    created() {

        this.repositories = {
            fabricante: this.getConectaSusRepository('cadastro.fabricante')
        }
    },
    computed: {

        fields() {

            return [
                {
                    name: 'cadastroFabricanteTipo.nome',
                    key: 'tipoNome',
                    label: 'Tipo',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'cadastroFabricante.nome',
                    key: 'nome',
                    label: 'Nome',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastroFabricante.cnpj',
                    key: 'cnpj',
                    label: 'CNPJ',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'actions',
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    filters: {
        cnpj: formats.formatCnpj,
    },
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.fabricante.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o fabricante?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error ],
}
</script>